import { retryBlacklist, retryCount } from '@shared/api-client/config';
import { QueryClient } from '@tanstack/react-query';
import { defaultMutationErrorHandler } from './mutationErrorHandler';

export default new QueryClient({
  defaultOptions: {
    mutations: {
      onError: defaultMutationErrorHandler,
    },
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 5 * 1000,
      notifyOnChangeProps: [
        'data',
        'status',
        'isLoading',
        'isSuccess',
        'isError',
      ],
      retry: (failureCount, error) => {
        // @ts-expect-error
        if (retryBlacklist.includes(error.status)) {
          return false;
        }
        return retryCount - 1 > failureCount;
      },
    },
  },
});
